import React from "react";
import { processedStatuses } from "statics/payroll";
import {
  payrollStatusToEnglish,
  payrollStatusToType,
} from "statics/statusToEnglishMapping";

import StatusBox from "components/StatusBox";

interface PayrollStatusProps {
  // Used as a status-map index key and passed to Array.includes, so treated
  // as a definite string even though propTypes did not mark it required.
  periodState: string;
  status: string;
}

const PayrollStatus = ({ periodState, status }: PayrollStatusProps) => {
  let currentStatus = periodState;

  const hasProcessed = processedStatuses.includes(status);
  // currentStatus should only be set to the period state if it is "WAITING_FOR_APPROVAL", which maps it to "Current"
  if (hasProcessed) {
    currentStatus = status;
  }

  const displayCurrentStatus =
    payrollStatusToEnglish[
      currentStatus as keyof typeof payrollStatusToEnglish
    ];

  return (
    <span>
      <StatusBox
        status={displayCurrentStatus}
        type={
          payrollStatusToType[currentStatus as keyof typeof payrollStatusToType]
        }
      />
    </span>
  );
};

export default PayrollStatus;
